import {type LexiconDoc} from '@atproto/lexicon'

export const putOnboardingData: LexiconDoc = {
  lexicon: 1,
  id: 'app.taderok.actor.putOnboardingData',
  defs: {
    main: {
      type: 'procedure',
      input: {
        encoding: 'application/json',
      },
    },
  },
}
